import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AIFleetPage from './AIFleetPage';
import { X } from 'lucide-react';

/**
 * AI车队页面带弹窗版本
 * 显示一个测试弹窗，关闭后显示正常的 GPT Backup 车队页面
 */
const AIFleetModalPage = () => {
  const [showModal, setShowModal] = useState(true);
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {/* 渲染 AI Fleet 页面 (gpt-backup) */}
      <AIFleetPage />

      {/* 测试弹窗 */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 animate-fade-in">
            {/* 关闭按钮 */}
            <button
              onClick={handleCloseModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="关闭"
            >
              <X size={24} />
            </button>

            {/* 弹窗内容 */}
            <div className="text-center">
              <div className="mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mx-auto flex items-center justify-center">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                测试弹窗
              </h2>

              <div className="space-y-3 text-left mb-6">
                <p className="text-gray-600">
                  这是一个测试弹窗，展示在 GPT Backup 车队页面上。
                </p>
                <p className="text-gray-600">
                  您可以在这里添加任何想要显示的内容：
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>重要公告信息</li>
                  <li>功能使用说明</li>
                  <li>促销活动通知</li>
                  <li>系统更新提示</li>
                </ul>
              </div>

              <button
                onClick={handleCloseModal}
                className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-6 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                我知道了
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fade-in {
          animation: fade-in 0.2s ease-out;
        }
      `}</style>
    </>
  );
};

export default AIFleetModalPage;
